import _ from 'lodash';
import { Markdown, Icon, Spinner } from '@scale/scaleui';
import { InteractionStepType, ContextDirectionsStepResponse } from '@scale/shared/types/chat';
import { useEffect, useState, useContext } from 'react';
import { Alert } from 'react-scale/components/scalers/tasks/ThreadedInteraction/TempComponents';
import { ChatTaskContext } from 'react-scale/components/scalers/tasks/ThreadedInteraction/contexts/ChatTaskContext';
import {
  useChatStoreExtract,
  useMostRecentPrompt,
  useMostRecentResponse,
  useStepParams,
  useStepResponse,
} from 'react-scale/components/scalers/tasks/Chat/hooks/ChatStore.hooks';
import { useStepSubmitHandler } from '../../hooks/useStepSubmitHandler';
import { StepWidthWrapper } from '../../step/StepWidthWrapper';
import { StepViewComponent } from '../stepDescriptor/types';

// TODO: @Matthew: Deprecate this component entirely once projects no longer have it.
export const ContextDirectionsTaskComponent: StepViewComponent = ({ responseIndex, complete }) => {
  const taskContext = useContext(ChatTaskContext);
  const config = useChatStoreExtract(state => state.config);
  const step = useStepParams(responseIndex);

  const response = useStepResponse<ContextDirectionsStepResponse>(responseIndex);
  const { onSubmit } = useStepSubmitHandler({
    responseIndex,
  });

  const lastResponse = useMostRecentResponse(responseIndex);
  const lastPrompt = useMostRecentPrompt(responseIndex);

  const [isFeedbackSubmitted, setIsFeedbackSubmitted] = useState(
    _.get(response, 'context.didRateFeedback'),
  );
  const [isFeedbackSubmissionLoading, setIsFeedbackSubmissionLoading] = useState(false);

  /* The output should always be the last response output unless this is a before step.
   * If this is a before step, we use the last prompt output.
   */
  const output = responseIndex < config.before.length ? lastPrompt : lastResponse;

  const onClickHandler = async (_likedVote: boolean) => {
    setIsFeedbackSubmissionLoading(true);
    onSubmit(
      {
        type: InteractionStepType.ContextDirections,
        output,
        context: { didRateFeedback: true },
      },
      responseIndex,
      step,
      undefined,
      true /* skip linting */,
    );
    setIsFeedbackSubmitted(true);
    setIsFeedbackSubmissionLoading(false);
  };

  useEffect(() => {
    if (!complete) {
      onSubmit(
        {
          type: InteractionStepType.ContextDirections,
          output,
        },
        responseIndex,
        step,
        undefined,
        true /* skip linting */,
      );
    }
  }, [complete, output, onSubmit, step, responseIndex]);

  if (!taskContext.directions) {
    return null;
  }

  return (
    <StepWidthWrapper>
      <div className="flex flex-col gap-2">
        <Alert variant="danger" className="max-w-full overflow-auto">
          <Markdown markdown="**Feedback on the Response:**" />
          <Markdown markdown={taskContext.directions} />
          <div className="flex items-center gap-2 pt-2">
            {isFeedbackSubmissionLoading && <Spinner size="sm" />}
            {!isFeedbackSubmissionLoading && (
              <>
                <Markdown
                  markdown={isFeedbackSubmitted ? '**Thank you!**' : '**Was this helpful?**'}
                />
                {!isFeedbackSubmitted && (
                  <>
                    <Icon
                      icon={['fas', 'thumbs-up']}
                      onClick={() => onClickHandler(true)}
                      className="z-20"
                      size="sm"
                      variant="success"
                      rounded
                    />

                    <Icon
                      icon={['fas', 'thumbs-down']}
                      onClick={() => onClickHandler(false)}
                      className="z-20"
                      size="sm"
                      variant="danger"
                      rounded
                    />
                  </>
                )}
              </>
            )}
          </div>
        </Alert>
      </div>
    </StepWidthWrapper>
  );
};
